// On-hover route prefetching: warms the lazy page chunk the moment a user
// hovers (desktop) or touches (mobile) an internal link, so navigation feels instant.
// Import paths mirror App.js exactly — webpack dedupes them into the same chunks.

const ROUTES = [
  ['/', () => import('../pages/Home')],
  ['/solutions', () => import('../pages/Solutions')],
  ['/solutions/team-building/:slug', () => import('../pages/GameDetail')],
  ['/solutions/:slug', () => import('../pages/SolutionDetail')],
  ['/about', () => import('../pages/About')],
  ['/insights', () => import('../pages/Insights')],
  ['/insights/:slug', () => import('../pages/InsightDetail')],
  ['/impact', () => import('../pages/Impact')],
  ['/impact/:slug', () => import('../pages/CaseStudyDetail')],
  ['/contact', () => import('../pages/Contact')],
  ['/workshops', () => import('../pages/Workshops')],
  ['/workshops/:slug/meeting', () => import('../pages/WorkshopMeeting')],
  ['/workshops/:slug', () => import('../pages/WorkshopDetail')],
  ['/privacy-policy', () => import('../pages/PrivacyPolicy')],
  ['/cookie-policy', () => import('../pages/CookiePolicy')],
  ['/terms-of-service', () => import('../pages/TermsOfService')],
  ['/ai-index', () => import('../pages/AIIndex')],
  ['/how-to-reference-us', () => import('../pages/HowToReferenceUs')],
  ['/retreats', () => import('../pages/Retreats')],
  ['/team-building-quiz', () => import('../pages/TeamBuildingQuiz')],
  ['/transformation-diagnostic', () => import('../pages/TransformationDiagnostic')],
  ['/go-team-blue-wave', () => import('../pages/BlueWaveGo')],
  ['/ecd-certification', () => import('../pages/ECDCertification')],
  ['/ecd-certification-bonaire', () => import('../pages/ECDBonaire')],
  ['/ecd-leadership', () => import('../pages/ECDLeadership')],
  ['/ecd-stakeholder', () => import('../pages/ECDStakeholder')],
  ['/ecd-courses', () => import('../pages/ECDCourses')],
  ['/cultural-transformation-tools', () => import('../pages/CulturalTransformationTools')],
  ['/creative-catalyst', () => import('../pages/CreativeCatalyst')],
  ['/tools', () => import('../pages/Tools')],
  ['/tools/:slug', () => import('../pages/ToolDetail')],
  ['/my-tools', () => import('../pages/MyTools')],
  ['/careers', () => import('../pages/Careers')],
  ['/careers/:slug', () => import('../pages/VacancyDetail')],
];

const prefetched = new Set();

const matchRoute = (pathname) => {
  const segs = pathname.split('/').filter(Boolean);
  for (const [pattern, loader] of ROUTES) {
    const pSegs = pattern.split('/').filter(Boolean);
    if (pSegs.length !== segs.length) continue;
    if (pSegs.every((p, i) => p.startsWith(':') || p === segs[i])) return [pattern, loader];
  }
  return null;
};

export const prefetchPath = (pathname) => {
  const match = matchRoute(pathname);
  if (!match) return;
  const [pattern, loader] = match;
  if (prefetched.has(pattern)) return;
  prefetched.add(pattern);
  loader().catch(() => prefetched.delete(pattern));
};

export const initLinkPrefetch = () => {
  if (navigator.connection?.saveData) return;

  const handle = (e) => {
    const a = e.target.closest?.('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    const href = a.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//')) return;
    prefetchPath(href.split('#')[0].split('?')[0]);
  };

  document.addEventListener('mouseover', handle, { passive: true });
  document.addEventListener('touchstart', handle, { passive: true });
};
